import React, { useState, useEffect } from 'react';
import {
  Box,
  Text,
  VStack,
  Button,
  Card,
  CardBody,
  CardHeader,
  Heading,
  Input,
  FormControl,
  FormLabel,
  useToast
} from '@chakra-ui/react';

interface AdminAuthProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
}

const AdminAuth: React.FC<AdminAuthProps> = ({ 
  children, 
  title = "Admin Access",
  description = "Enter the admin password to access this page"
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  // Check if already authenticated from sessionStorage
  useEffect(() => {
    const savedAuth = sessionStorage.getItem('adminAuth');
    if (savedAuth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = () => {
    setLoading(true);
    const correctPassword = process.env.REACT_APP_ADMIN_PASSWORD || 'admin123';
    
    // Small delay to show loading state
    setTimeout(() => {
      if (password === correctPassword) {
        setIsAuthenticated(true);
        sessionStorage.setItem('adminAuth', 'true');
        toast({
          title: "Access granted",
          description: "Welcome to the admin panel",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Access denied",
          description: "Incorrect password",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
      setLoading(false);
    }, 500);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  if (!isAuthenticated) {
    return (
      <Box maxW="400px" mx="auto" p={8} mt={20}>
        <Card>
          <CardHeader>
            <Heading size="lg" textAlign="center">{title}</Heading>
          </CardHeader>
          <CardBody>
            <VStack spacing={4}>
              <Text textAlign="center" color="gray.600">
                {description}
              </Text>
              <FormControl>
                <FormLabel>Password</FormLabel>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyPress={handleKeyPress}
                  placeholder="Enter admin password"
                  autoFocus
                />
              </FormControl>
              <Button
                colorScheme="blue"
                onClick={handleLogin}
                w="100%"
                isLoading={loading}
                loadingText="Authenticating..."
              >
                Access Panel
              </Button>
            </VStack>
          </CardBody>
        </Card>
      </Box>
    );
  }

  return <>{children}</>;
};

export default AdminAuth;